// src/routes/MainRoutes.jsx
import React from "react";
import { Route } from "react-router-dom";
import MainLayout from "../components/MainLayout";
import Home from "../pages/Home/Home";
import Insurance from "../pages/Insurance/Insurance";
import RechargeAndBillPayment from "../pages/Recharge/RechargeAndBillPayment";
import AboutUs from "../pages/AboutUs/AboutUs";
import ContactUs from "../pages/ContactUs/ContactUs";
import RefundPolicy from "../pages/Policies/RefundPolicy";
import GrievancePolicy from "../pages/Policies/GrievancePolicy";
import PrivacyPolicy from "../pages/Policies/PrivacyPolicy";
import TermsAndConditions from "../pages/Policies/TermsAndConditions";
import FAQ from "../pages/FAQ/FAQ";

// RECHARGE ROUTES
import MobileRecharge from "../pages/Recharge/MobileRecharge";
import DthRecharge from "../pages/Recharge/DthRecharge";
import GooglePlayRedeemCode from "../pages/Recharge/GooglePlayRedeemCode";
import RechargeOrderConfirmation from "../pages/Recharge/OrderConfirmation";
import RechargeOrderSummary from "../pages/Recharge/OrderSummary";

// BILL PAYMENT ROUTES
import BillPayment from "../pages/BillPayment/BillPayment";
import BillPaymentOrderSummary from "../pages/BillPayment/OrderSummary";
import BillPaymentOrderConfirmation from "../pages/BillPayment/OrderConfirmation";

// NSDL PAN CARD ROUTES
import NsdlPanCard from "../pages/Services/NsdlPanCard/NsdlPanCard";
import PANApplication from "../pages/Services/NsdlPanCard/PANApplication";
import NsdlReceipt from "../pages/Services/NsdlPanCard/NsdlReceipt";
import PanStatus from "../pages/Services/NsdlPanCard/PanStatus";
import PanHistory from "../pages/Services/NsdlPanCard/PanHistory";

// AADHAAR TO PAN ROUTES
import AadhaarToPAN from "../pages/Services/AadhaarToPAN/AadhaarToPAN";
import AadhaarToPANReport from "../pages/Services/AadhaarToPAN/AadhaarToPANReport";

// UTI PAN CARD ROUTES
import UtiPanCard from "../pages/Services/UtiPanCard/UtiPanCard";
import ViewCredentials from "../pages/Services/UtiPanCard/ViewCredentials";
import BuyCoupon from "../pages/Services/UtiPanCard/BuyCoupon";
import PanCouponHistory from "../pages/Services/UtiPanCard/PANCouponHistory";
import AgentRegistration from "../pages/Services/UtiPanCard/AgentRegistration";
import UtiEwalletPanCard from "../pages/Services/UtiPanCard/E-Wallet/UtiEwallet";
import UtiEwalletReport from "../pages/Services/UtiPanCard/E-Wallet/UtiEWalletReport";

// INSURANCE POSP ROUTES
import InsurancePosp from "../pages/Services/InsurancePosp/InsurancePosp";
import PolicyHistory from "../pages/Services/InsurancePosp/PolicyHistory";

// PPI MONEY TRANSFER
import PPIMoneyTransfer from "../pages/Services/PPIMoneyTransfer/PPIMoneyTransfer";
import SenderHome from "../pages/Services/PPIMoneyTransfer/SenderHome";
import AddBeneficiary from "../pages/Services/PPIMoneyTransfer/AddBeneficiary";
import FundTransfer from "../pages/Services/PPIMoneyTransfer/FundTransfer";
import PPIFundTransferHistory from "../pages/Services/PPIMoneyTransfer/PPIMoneyTransferHistory";
import VerifyAadhaar from "../pages/Services/PPIMoneyTransfer/VerifyAadhaar";
import VerifyPAN from "../pages/Services/PPIMoneyTransfer/VerifyPAN";
import MoneyTransferReceipt from "../pages/Services/PPIMoneyTransfer/Receipt";
import ClaimRefund from "../pages/Services/PPIMoneyTransfer/ClaimRefund";

// FINO MONEY TRANSFER ROUTES
import FinoMoneyTransfer from "../pages/Services/FinoMoneyTransfer/FinoMoneyTransfer";
import FinoSenderHome from "../pages/Services/FinoMoneyTransfer/SenderHome";
import FinoBeneficiary from "../pages/Services/FinoMoneyTransfer/AddBeneficiary";
import FinoFundTransfer from "../pages/Services/FinoMoneyTransfer/FundTransfer";
import FinoMoneyTransferHistory from "../pages/Services/FinoMoneyTransfer/MoneyTransferHistory";
import FinoReceipt from "../pages/Services/FinoMoneyTransfer/Receipt";
import FinoClaimRefund from "../pages/Services/FinoMoneyTransfer/ClaimRefund";

// BC AGENT ONBOARDING ROUTES
import BcAgentOnboarding from "../pages/Services/BCAgentOnboarding/BcAgentOnboarding";
import FinoEkyc from "../pages/Services/BCAgentOnboarding/FinoEkyc";
import JioEkyc from "../pages/Services/BCAgentOnboarding/JioEkyc";
import MerchantOnboardingStatus from "../pages/Services/BCAgentOnboarding/MerchantStatus";

// UPI CASH POINT ROUTES
import UPICashPoint from "../pages/Services/UPICashPoint/UPICashPoint";

// SUBCRIOTION ROUTES
import Subscription from "../pages/Services/Subscription/Subscription";

import Profile from "../pages/Profile/Profile";
import Transactions from "../pages/Wallet/Transactions";
import Wallet from "../pages/Wallet/Wallet";
import CreditCardToBankTransfer from "../pages/CreditCardTransfer/CreditCardToBankTransfer";
import SsoLogin from "../pages/Login/SSOLogin";
import FinoCSPLanding from "../pages/LandingPages/FinoCSPLanding";
import MantraDevice from "../pages/Services/MantraDevice/MantraDevice";
import CMS from "../pages/Services/CMS/Cms";
import CmsReport from "../pages/Services/CMS/CmsReport";
import BankingServices from "../pages/Services/BCAgentOnboarding/BankingServices";
import PaymentStatus from "../pages/Wallet/PaymentStatus";

// import Recharge from '../pages/Recharge';

const MainRoutes = (
  <Route element={<MainLayout />}>
    <Route path="/" element={<Home />} />

    <Route path="/sso-login" element={<SsoLogin />} />

    <Route
      path="/recharge-and-bill-payment"
      element={<RechargeAndBillPayment />}
    />
    <Route path="/mobile-recharge" element={<MobileRecharge />} />
    <Route path="/dth-recharge" element={<DthRecharge />} />
    <Route path="/google-play-redeem-code" element={<GooglePlayRedeemCode />} />
    <Route path="/recharge-order-summary" element={<RechargeOrderSummary />} />
    <Route
      path="/recharge-order-confirmation"
      element={<RechargeOrderConfirmation />}
    />

    <Route path="/bill-payment/:category" element={<BillPayment />} />
    <Route
      path="/bill-payment/order-summary"
      element={<BillPaymentOrderSummary />}
    />
    <Route
      path="/bill-payment/order-confirmation"
      element={<BillPaymentOrderConfirmation />}
    />

    <Route path="/insurance" element={<Insurance />} />

    <Route path="/nsdl-pancard" element={<NsdlPanCard />} />
    <Route
      path="/nsdl-pancard/pan-application/:applicationType"
      element={<PANApplication />}
    />
    <Route path="/nsdl-pancard/pan-status" element={<PanStatus />} />
    <Route path="/nsdl-pancard/history" element={<PanHistory />} />
    <Route path="/nsdl-pancard/receipt" element={<NsdlReceipt />} />

    <Route path="/uti-pancard" element={<UtiPanCard />} />
    <Route path="/uti-pancard/view-credentials" element={<ViewCredentials />} />
    <Route path="/uti-pancard/buy-coupon" element={<BuyCoupon />} />
    <Route
      path="/uti-pancard/pan-coupon-history"
      element={<PanCouponHistory />}
    />
    <Route
      path="/uti-pancard/agent-registration"
      element={<AgentRegistration />}
    />
    <Route path="/uti-pancard/e-wallet" element={<UtiEwalletPanCard />} />
    <Route path="/uti-pancard/e-wallet/report" element={<UtiEwalletReport />} />

    <Route path="/aadhaar-to-pan" element={<AadhaarToPAN />} />
    <Route path="/aadhaar-to-pan/report" element={<AadhaarToPANReport />} />

    <Route path="/insurance-posp" element={<InsurancePosp />} />
    <Route path="/insurance-posp/history" element={<PolicyHistory />} />

    <Route path="/ppi-money-transfer" element={<PPIMoneyTransfer />} />
    <Route path="/ppi-money-transfer/sender-home" element={<SenderHome />} />
    <Route
      path="/ppi-money-transfer/add-beneficiary"
      element={<AddBeneficiary />}
    />
    <Route
      path="/ppi-money-transfer/fund-transfer"
      element={<FundTransfer />}
    />
    <Route
      path="/ppi-money-transfer/receipt"
      element={<MoneyTransferReceipt />}
    />
    <Route
      path="/ppi-money-transfer/fund-transfer-history"
      element={<PPIFundTransferHistory />}
    />
    <Route
      path="/ppi-money-transfer/verify-aadhaar"
      element={<VerifyAadhaar />}
    />
    <Route path="/ppi-money-transfer/verify-pan" element={<VerifyPAN />} />
    <Route path="/ppi-money-transfer/claim-refund" element={<ClaimRefund />} />

    {/* FINO MONEY TRANSFER ROUTES */}
    <Route path="/fino-money-transfer" element={<FinoMoneyTransfer />} />
    <Route
      path="/fino-money-transfer/sender-home"
      element={<FinoSenderHome />}
    />
    <Route
      path="/fino-money-transfer/add-beneficiary"
      element={<FinoBeneficiary />}
    />
    <Route
      path="/fino-money-transfer/fund-transfer"
      element={<FinoFundTransfer />}
    />
    <Route
      path="/fino-money-transfer/money-transfer-history"
      element={<FinoMoneyTransferHistory />}
    />
    <Route path="/fino-money-transfer/receipt" element={<FinoReceipt />} />
    <Route
      path="/fino-money-transfer/claim-refund"
      element={<FinoClaimRefund />}
    />
    {/* FINO MONEY TRANSFER ROUTES */}

    {/* BC AGENT ONBOARDING ROUTES */}
    <Route path="/bc-agent-onboarding" element={<BcAgentOnboarding />} />
    <Route
      path="/bc-agent-onboarding/merchant-onboarding-status"
      element={<MerchantOnboardingStatus />}
    />
    <Route path="/bc-agent-onboarding/fino-ekyc" element={<FinoEkyc />} />
    <Route path="/bc-agent-onboarding/jio-ekyc" element={<JioEkyc />} />
    {/* BC AGENT ONBOARDING ROUTES */}

    {/* UPI CASH POINT ROUTES */}
    <Route path="/upi-cash-point" element={<UPICashPoint />} />
    {/* UPI CASH POINT ROUTES */}

    <Route path="/cms" element={<CMS />} />
    <Route path="/cms/history" element={<CmsReport />} />

    <Route path="/banking-services" element={<BankingServices />} />

    <Route path="/subscription" element={<Subscription />} />

    <Route
      path="/credit-card-to-bank-transfer"
      element={<CreditCardToBankTransfer />}
    />

    <Route path="/profile" element={<Profile />} />
    <Route path="/transactions" element={<Transactions />} />

    <Route path="/wallet" element={<Wallet />} />

    <Route path="/about-us" element={<AboutUs />} />
    <Route path="/contact-us" element={<ContactUs />} />
    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
    <Route path="/refund-policy" element={<RefundPolicy />} />
    <Route path="/grievance-policy" element={<GrievancePolicy />} />
    <Route path="/faq" element={<FAQ />} />
    <Route path="/support" element={<ContactUs />} />

    <Route path="/mantra-device" element={<MantraDevice />} />

    <Route path="/payment-status" element={<PaymentStatus />} />

    {/* Add more main routes here */}
  </Route>
);

export default MainRoutes;
